import {scrollAnchors} from '@wix/document-services-implementation'
import type {PublicMethodUtils} from '@wix/document-services-types'
import type {ResponsiveScrollAnchorsPublicAPI} from '@wix/document-services-public-types'
import type {PublicModuleDeclaration} from '../../documentServicesInitialisation'

export default function (
    publicMethodUtils: PublicMethodUtils
): PublicModuleDeclaration<ResponsiveScrollAnchorsPublicAPI> {
    return {
        initMethod: scrollAnchors.init,
        methods: {
            components: {
                anchor: {
                    get: publicMethodUtils.defineGetter(scrollAnchors.get),
                    update: publicMethodUtils.defineDataManipulationAction(scrollAnchors.update),
                    remove: publicMethodUtils.defineDataManipulationAction(scrollAnchors.remove)
                }
            },
            pages: {
                anchors: {
                    getPageAnchors: publicMethodUtils.defineGetter(scrollAnchors.getPageAnchors)
                }
            }
        }
    }
}
